// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as GeoRegion from "../../../../../common/store/GeoRegion.bs.js";
import * as Caml_option from "../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as VehicleConfig from "../../../../../common/store/VehicleConfig.bs.js";

function getVideoUrl(category, language, geo_region) {
  var region = Js_dict.get(VehicleConfig.vehicleGeoregionConfig, GeoRegion.toString(geo_region));
  if (region === undefined) {
    return "";
  }
  var vehicle_category = Js_dict.get(Caml_option.valFromOption(region), category);
  if (vehicle_category !== undefined) {
    return vehicle_category.video_url;
  } else {
    return "";
  }
}

function getContent(category, language, geo_region) {
  return {
          header_title: "Porter Partner Care",
          title: "Healthcare Membership",
          insurance_provided_by: "Powered by",
          insurance_provider: "Onsurity",
          name: "Name",
          policy_number: "Policy Number",
          validity: "Validity",
          coverage: "Coverage",
          hospitalization: "Group Health Insurance",
          accidental: "Group Personal Accidental",
          sum_insured: "Sum Insured",
          as_per_the_policy: "As per the policy",
          benefits: "Benefits",
          view_video: "View Video",
          call: "Call",
          tnc: "Terms and Conditions",
          videoUrl: getVideoUrl(category, language, geo_region),
          ineligibleCardDefaultText: "Hey there! You don't currently qualify for Porter Partner Care. Keep an eye out for updates on how you can become eligible next month!",
          getIneligibleCardDynamicText: (function (login_hours, completion_score) {
              return "Please complete " + login_hours + " login hours and accept and complete at least " + completion_score + "% of your orders this month to get FREE health & accidental insurance coverage next month !*";
            })
        };
}

var English = {
  getContent: getContent
};

function getContent$1(category, language, geo_region) {
  return {
          header_title: "पोर्टर पार्टनर केयर",
          title: "स्वास्थ्य सेवा सदस्यता",
          insurance_provided_by: "द्वारा संचालित",
          insurance_provider: "ऑंसुरिटी",
          name: "नाम",
          policy_number: "नीति संख्या",
          validity: "वैधता",
          coverage: "कवरेज",
          hospitalization: "समूह स्वास्थ्य बीमा",
          accidental: "समूह व्यक्तिगत दुर्घटना",
          sum_insured: "बीमा - राशि",
          as_per_the_policy: "नीति के अनुसार",
          benefits: "फ़ायदे",
          view_video: "वीडियो देखें",
          call: "कॉल",
          tnc: "नियम और शर्तें",
          videoUrl: getVideoUrl(category, language, geo_region),
          ineligibleCardDefaultText: "आप वर्तमान में पोर्टर पार्टनर केयर के लिए योग्य नहीं हैं। अगले महीने आप कैसे पात्र बन सकते हैं, इस पर अपडेट पर नज़र रखें!",
          getIneligibleCardDynamicText: (function (login_hours, completion_score) {
              return "अगले महीने फ्री हेल्थ और एक्सीडेंटल इन्शुरन्स पाने के लिए इस महीने " + login_hours + " घंटे लॉगिन करे और कम से कम " + completion_score + "% ऑर्डर्स एक्सेप्ट करके पूरे करे !*";
            })
        };
}

var Hindi = {
  getContent: getContent$1
};

function getContent$2(category, language, geo_region) {
  return {
          header_title: "போர்ட்டர் பார்ட்னர் கேர்",
          title: "ஹெல்த்கேர் உறுப்பினர்",
          insurance_provided_by: "இயக்கப்படுகிறது",
          insurance_provider: "ஒண்சுருட்டி",
          name: "பெயர்",
          policy_number: "கொள்கை எண்",
          validity: "செல்லுபடியாகும்",
          coverage: "காப்பீட்டின் பலன்கள்",
          hospitalization: "குழு மருத்துவ காப்பீடு",
          accidental: "விபத்து காப்பீடு",
          sum_insured: "காப்பீட்டு தொகை",
          as_per_the_policy: "விதிகளின் படி",
          benefits: "பலன்கள்",
          view_video: "காணொளியைக் காண்க",
          call: "அழைக்க",
          tnc: "விதிமுறைகள் மற்றும் நிபந்தனைகள்",
          videoUrl: getVideoUrl(category, language, geo_region),
          ineligibleCardDefaultText: "நீங்கள் தற்போது போர்ட்டர் பார்ட்னர் கேர்க்கு தகுதி பெறவில்லை. அடுத்த மாதம் நீங்கள் எவ்வாறு தகுதி பெறலாம் என்பது குறித்த அறிவிப்புகளுக்குக் கண்காணியுங்கள்!",
          getIneligibleCardDynamicText: (function (login_hours, completion_score) {
              return "அடுத்த மாதத்திற்கான இலவச உடல்நலம் மற்றும் விபத்து காப்பீட்டு கவரேஜ் பெற, இந்த மாதத்தில், " + login_hours + " ஆர்டர்களை " + completion_score + "% லாகின் நேரத்தில் முடிக்கவும் !*";
            })
        };
}

var Tamil = {
  getContent: getContent$2
};

function getContent$3(category, language, geo_region) {
  return {
          header_title: "ಪೋರ್ಟರ್ ಪಾರ್ಟ್ನರ್ ಕೇರ್",
          title: "ಆರೋಗ್ಯ ಸದಸ್ಯತ್ವ",
          insurance_provided_by: "ಇವರಿಂದ ನಡೆಸಲ್ಪಡುತ್ತಿದೆ",
          insurance_provider: "ಆನ್ಶೂರಿಟಿ",
          name: "ಹೆಸರು",
          policy_number: "ಪಾಲಿಸಿ ಸಂಖ್ಯೆ",
          validity: "ಮಾನ್ಯತೆಯ ಅವಧಿ",
          coverage: "ಮಿತಿ",
          hospitalization: "ಗುಂಪು ಆರೋಗ್ಯ ವಿಮೆ",
          accidental: "ಗುಂಪು ವೈಯಕ್ತಿಕ ಆಕಸ್ಮಿಕ",
          sum_insured: "ವಿಮಾ ಮೊತ್ತ",
          as_per_the_policy: "ನೀತಿಯ ಪ್ರಕಾರ",
          benefits: "ಪ್ರಯೋಜನಗಳು",
          view_video: "ವೀಡಿಯೊ ವೀಕ್ಷಿಸಿ",
          call: "ಕರೆ ಮಾಡಿ",
          tnc: "ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು",
          videoUrl: getVideoUrl(category, language, geo_region),
          ineligibleCardDefaultText: "ನೀವು ಪ್ರಸ್ತುತ ಪೋರ್ಟರ್ ಪಾರ್ಟ್‌ನರ್ ಕೇರ್‌ಗೆ ಅರ್ಹತೆ ಪಡೆದಿಲ್ಲ. ಮುಂದಿನ ತಿಂಗಳು ನೀವು ಹೇಗೆ ಅರ್ಹರಾಗಬಹುದು ಎಂಬುದರ ಕುರಿತು ನವೀಕರಣಗಳಿಗಾಗಿ ಗಮನವಿರಲಿ!",
          getIneligibleCardDynamicText: (function (login_hours, completion_score) {
              return "ಈ ತಿಂಗಳು " + login_hours + " ಆರ್ಡರ್‌ಗಳು ಮತ್ತು " + completion_score + "% ಲಾಗಿನ್ ಸಮಯವನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ ಮತ್ತು ಮುಂದಿನ ತಿಂಗಳು ಉಚಿತ ಆರೋಗ್ಯ ಮತ್ತು ಆಕಸ್ಮಿಕ ವಿಮಾ ರಕ್ಷಣೆಯನ್ನು ಪಡೆಯಿರಿ !*";
            })
        };
}

var Kannada = {
  getContent: getContent$3
};

function getContent$4(category, language, geo_region) {
  return {
          header_title: "पोर्टर पार्टनर केयर",
          title: "आरोग्य सेवा सदस्यत्व",
          insurance_provided_by: "द्वारे समर्थित",
          insurance_provider: "ओंसुरिटी",
          name: "नाव",
          policy_number: "पॉलिसी क्रमांक",
          validity: "वैधता",
          coverage: "कव्हरेज",
          hospitalization: "गट आरोग्य विमा",
          accidental: "गट वैयक्तिक अपघाती",
          sum_insured: "विम्याची रक्कम",
          as_per_the_policy: "धोरणानुसार",
          benefits: "फायदे",
          view_video: "व्हिडिओ पहा",
          call: "कॉल करा",
          tnc: "नियम आणि अटी",
          videoUrl: getVideoUrl(category, language, geo_region),
          ineligibleCardDefaultText: "तुम्ही सध्या पोर्टर पार्टनर केअरसाठी पात्र नाही. पुढील महिन्यात तुम्ही पात्र कसे होऊ शकता यावरील अद्यतनांसाठी लक्ष ठेवा!",
          getIneligibleCardDynamicText: (function (login_hours, completion_score) {
              return "पुढील महिन्यात मोफत आरोग्य आणि अपघाती विमा मिळविण्यासाठी, या महिन्यात " + login_hours + " तास लॉग इन करा आणि किमान " + completion_score + "% ऑर्डर स्वीकारा आणि पूर्ण करा !*";
            })
        };
}

var Marathi = {
  getContent: getContent$4
};

function getContent$5(category, language, geo_region) {
  return {
          header_title: "పోర్టర్ పార్టనర్ కేర్",
          title: "ఆరోగ్య సంరక్షణ సభ్యత్వం",
          insurance_provided_by: "దీని ద్వారా ఆధారితం",
          insurance_provider: "ఒంసురిటీ",
          name: "పేరు",
          policy_number: "పాలసీ సంఖ్య",
          validity: "చెల్లుబాటు",
          coverage: "కవరేజ్",
          hospitalization: "గ్రూప్ హెల్త్ ఇన్సూరెన్స్",
          accidental: "గ్రూప్ పర్సనల్ యాక్సిడెంటల్",
          sum_insured: "భీమా చేసిన మొత్తము",
          as_per_the_policy: "పాలసీ ప్రకారం",
          benefits: "లాభాలు",
          view_video: "వీడియో చూడండి",
          call: "కాల్ చేయండి",
          tnc: "నిబంధనలు మరియు షరతులు",
          videoUrl: getVideoUrl(category, language, geo_region),
          ineligibleCardDefaultText: "మీరు ప్రస్తుతం పోర్టర్ పార్టనర్ కేర్‌కు అర్హత పొందలేదు. వచ్చే నెలలో మీరు ఎలా అర్హత పొందవచ్చనే దాని గురించిన అప్‌డేట్‌ల కోసం ఒక కన్ను వేసి ఉంచండి!",
          getIneligibleCardDynamicText: (function (login_hours, completion_score) {
              return "వచ్చే నెలలో ఉచిత ఆరోగ్య మరియు ప్రమాద బీమా కవరేజీని పొందడానికి దయచేసి ఈ నెలలో " + login_hours + " ఆర్డర్‌లు మరియు " + completion_score + "% లాగిన్ గంటలను పూర్తి చేయండి !*";
            })
        };
}

var Telugu = {
  getContent: getContent$5
};

function getContent$6(category, language, geo_region) {
  return {
          header_title: "പോർട്ടർ പാർട്ണർ കെയർ",
          title: "ഹെൽത്ത് കെയർ അംഗത്വം",
          insurance_provided_by: "പ്രായോജകർ",
          insurance_provider: "ഓൺഷൂറിട്ടി",
          name: "പേര്",
          policy_number: "പോളിസി നമ്പർ",
          validity: "സാധുത",
          coverage: "കവറേജ്",
          hospitalization: "ഗ്രൂപ്പ് ആരോഗ്യ ഇൻഷുറൻസ്",
          accidental: "ഗ്രൂപ്പ് പേർസണൽ ആക്‌സിഡന്റൽ ",
          sum_insured: "വാഗ്ദാനം ചെയ്ത തുക",
          as_per_the_policy: "നയം അനുസരിച്ച്",
          benefits: "ആനുകൂല്യങ്ങൾ",
          view_video: "വീഡിയോ കാണു",
          call: "കോൾ",
          tnc: "ഉപാധികളും നിബന്ധനകളും",
          videoUrl: getVideoUrl(category, language, geo_region),
          ineligibleCardDefaultText: "നിങ്ങൾ നിലവിൽ പോർട്ടർ പാർട്ണർ കെയറിന് യോഗ്യത നേടിയിട്ടില്ല. അടുത്ത മാസം നിങ്ങൾക്ക് എങ്ങനെ യോഗ്യത നേടാം എന്നതിനെക്കുറിച്ചുള്ള അപ്‌ഡേറ്റുകൾക്കായി ശ്രദ്ധിക്കുക!",
          getIneligibleCardDynamicText: (function (login_hours, completion_score) {
              return "അടുത്ത മാസം സൗജന്യ ആരോഗ്യ, അപകട ഇൻഷുറൻസ് പരിരക്ഷ ലഭിക്കാൻ ഈ മാസം " + login_hours + " ഓർഡറുകളും " + completion_score + "% മണിക്കൂർ ലോഗിൻ സമയവും പൂർത്തിയാക്കുക !*";
            })
        };
}

var Malayalam = {
  getContent: getContent$6
};

export {
  getVideoUrl ,
  English ,
  Hindi ,
  Tamil ,
  Kannada ,
  Marathi ,
  Telugu ,
  Malayalam ,
  
}
/* VehicleConfig Not a pure module */
